import * as Onboarding from '../_layout/OnboardingComponents'
import { IdentityConfirmationContent } from './_layout/IdentityConfirmationContent'
import { IdentityConfirmationSideMenu } from './_layout/IdentityConfirmationSideMenu'

function IdentityConfirmationPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <IdentityConfirmationContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <IdentityConfirmationSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default IdentityConfirmationPage
